import { simpleSet } from '@r/reducers/utils';

const setCalculationModeHingesSearchText = simpleSet as
  redux.reducers.calculationMode.projects.currentProject.settings.materials.hinges.searchText;

export const searchText = setCalculationModeHingesSearchText(
  'SET_CALCULATION_MODE_CURRENT_PROJECT_HINGES_SEARCH_TEXT',
  ''
);
